import React, { useEffect, useState } from "react";
import StageClientTable from "../../components/ReportsComponents/ClientListStage";
import StageHistoryTable from "../../components/ReportsComponents/ClientStageHistoryTable";
import StageDurationAnalytics from "../../components/ReportsComponents/ClientStageDurationAnalytics";
import ClientStageOverview from "../../components/ReportsComponents/ClientStageOverview";
import SummaryApi from "../../common/SummaryApi";
import api from "../../common/apiClient";

import * as XLSX from "xlsx";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import MISFilterDrawer from "../../components/MISFilterDrawer";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const ClientStageReport = () => {
  const [overview, setOverview] = useState(null);

  const [durationData, setDurationData] = useState([]);

  const [historyData, setHistoryData] = useState([]);

  const [clientData, setClientData] = useState([]);

  const [showFilters, setShowFilters] = useState(false);

  const [divisions, setDivisions] = useState([]);

  const [users, setUsers] = useState([]);

  const [stages, setStages] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  const [filterTarget, setFilterTarget] = useState("client");
 
  const [clientPagination, setClientPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  const [historyPagination, setHistoryPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  const [overviewFilters, setOverviewFilters] = useState({
    filterType: "thisMonth",
  });

  const [durationFilters, setDurationFilters] = useState({
    filterType: "thisMonth",
  });

  const [historyFilters, setHistoryFilters] = useState({
    filterType: "thisMonth",
    divisionId: "",
    userId: "",
    stageId: "",
    fromDate: "",
    toDate: "",
  });

  const [clientFilters, setClientFilters] = useState({
    filterType: "thisMonth",
    divisionId: "",
    userId: "",
    stageId: "",
    fromDate: "",
    toDate: "",
  });

  const fetchMasters = async () => {
    try {
      const [divisionRes, userRes, stageRes] = await Promise.all([
        api({
          url: SummaryApi.getAllDivisions.url,
          method: SummaryApi.getAllDivisions.method,
        }),

        api({
          url: SummaryApi.getAllUsers.url,
          method: SummaryApi.getAllUsers.method,
        }),

        api({
          url: SummaryApi.getAllStages.url,
          method: SummaryApi.getAllStages.method,
        }),
      ]);

      setDivisions(divisionRes?.data?.data || []);

      setUsers(userRes?.data?.data || []);

      setStages(stageRes?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchOverview = async () => {
    try {
      const params = new URLSearchParams(overviewFilters);

      const res = await api({
        url: `${SummaryApi.clientStageReportOverview.url}?${params}`,
        method: SummaryApi.clientStageReportOverview.method,
      });

      if (res.data.success) {
        setOverview(res.data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const fetchDuration = async () => {
    try {
      const params = new URLSearchParams(durationFilters);

      const res = await api({
        url: `${SummaryApi.clientStageDurationReport.url}?${params}`,
        method: SummaryApi.clientStageDurationReport.method,
      });

      if (res.data.success) {
        setDurationData(res.data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchClientList = async (page = 1, filtersData = clientFilters) => {
    try {
      const params = new URLSearchParams({
        ...filtersData,
        search: searchTerm,
        page,
        limit: clientPagination.limit,
      });

      const res = await api({
        url: `${SummaryApi.clientStageListReport.url}?${params}`,
        method: SummaryApi.clientStageListReport.method,
      });

      if (res.data.success) {
        setClientData(res.data.data);

        setClientPagination(res.data.pagination);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const fetchHistory = async (
  page = historyPagination.page,
  filtersData = historyFilters
  ) => {
    try {
      const params = new URLSearchParams({
        ...filtersData,
        page,
        limit: historyPagination.limit,
      });

      const res = await api({
        url: `${SummaryApi.clientStageHistoryReport.url}?${params}`,
        method: SummaryApi.clientStageHistoryReport.method,
      });

      if (res.data.success) {
        setHistoryData(res.data.data || []);

        setHistoryPagination(
          res.data.pagination || {
            page,
            limit: historyPagination.limit,
            total: 0,
            totalPages: 0,
          }
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchMasters();

    fetchOverview();

    fetchDuration();

    fetchHistory();

    fetchClientList();

    // eslint-disable-next-line
  }, []);

  const handleApplyFilters = async () => {
    setShowFilters(false);

    switch (filterTarget) {
      case "overview":
        await fetchOverview();
        break;

      case "duration":
        await fetchDuration();
        break;

      case "history":
        await fetchHistory(1);
        break;

      case "client":
        await fetchClientList(1);
        break;

      default:
        break;
    }
  };

  const overviewActiveFiltersCount =
    Object.entries(overviewFilters || {}).filter(
      ([key, value]) => key !== "filterType" && value
    ).length;

  const durationActiveFiltersCount =
    Object.entries(durationFilters || {}).filter(
      ([key, value]) => key !== "filterType" && value
    ).length;

  const historyActiveFiltersCount =
    Object.entries(historyFilters || {}).filter(
      ([key, value]) => key !== "filterType" && value
    ).length;

  const clientActiveFiltersCount =
    Object.entries(clientFilters || {}).filter(
      ([key, value]) => key !== "filterType" && value
    ).length;

  const handleClientPage = (page) => {
    fetchClientList(page);
  };

  const handleHistoryPage = (page) => {
    fetchHistory(page);
  };

  const handleClientLimit = (limit) => {
    setClientPagination((prev) => ({
      ...prev,
      limit,
      page: 1,
    }));

    fetchClientList(1);
  };

  const handleHistoryLimit = (limit) => {
    setHistoryPagination((prev) => ({
      ...prev,
      limit,
      page: 1,
    }));

    fetchHistory(1);
  };

  const exportExcel = () => {
    const rows = clientData.map((item) => ({
      ClientId: item.clientId,
      ClientName: item.clientName,
      ContactName: item.contactName,
      ContactPhone: item.contactPhone,
      Stage: item.stageId?.stageName,
      EstimatedValue: item.estimatedValue,
      ExpectedValue: item.expectedValue,
      Owner: `${item.userId?.firstName || ""} ${item.userId?.lastName || ""}`,
    }));

    const ws = XLSX.utils.json_to_sheet(rows);

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Client Stages");

    XLSX.writeFile(wb, "ClientStageReport.xlsx");

  };

  const exportPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(16);

    doc.text("Client Stage Report", 14, 15);

    autoTable(doc, {
      startY: 25,

      head: [["Client", "Stage", "Estimated", "Expected"]],

      body: clientData.map((item) => [
        item.clientName,
        item.stageId?.stageName,
        item.estimatedValue,
        item.expectedValue,
      ]),
    });

    doc.save("ClientStageReport.pdf");

  };

  return (
    <div className="space-y-2 p-4">
      {/* Header */}

      <div className="flex items-center gap-3 mb-6">
        <button
          onClick={() => navigate(-1)}
          className="p-2 rounded-full hover:bg-gray-100 transition"
        >
          <FaArrowLeft className="w-5 h-5" />
        </button>

        <div>
          <h1 className="text-2xl font-bold text-gray-900">
            Client Stage Report
          </h1>

          <p className="text-sm text-gray-500">
            Track pipeline movement, stage analytics and client progress.
          </p>
        </div>
      </div>
      {/* Overview */}
      <ClientStageOverview 
      data={overview}
       filters={overviewFilters}
       setFilters={setOverviewFilters}
       activeFiltersCount={overviewActiveFiltersCount}
       onFilterClick={() => {
          setFilterTarget("overview");
          setShowFilters(true);
       }}        
      />
      {/* Duration */}
      <StageDurationAnalytics
       data={durationData} 
       filters={durationFilters}
       setFilters={setDurationFilters}
       activeFiltersCount={durationActiveFiltersCount}
       onFilterClick={() => {
          setFilterTarget("duration");
          setShowFilters(true);
       }}
       />
      {/* History */}
      <StageHistoryTable
        data={historyData}
        pagination={historyPagination}
        onPageChange={handleHistoryPage}
        onItemsPerPageChange={handleHistoryLimit}
        filters={historyFilters}
        setFilters={setHistoryFilters}
        activeFiltersCount={historyActiveFiltersCount}
        onFilterClick={() => {
          setFilterTarget("history");
          setShowFilters(true);
        }}
      />
      {/* Client List */}
      <StageClientTable
        data={clientData}
        pagination={clientPagination}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        onExportExcel={exportExcel}
        onExportPDF={exportPDF}
        onPageChange={handleClientPage}
        onItemsPerPageChange={handleClientLimit}
        filters={clientFilters}
        setFilters={setClientFilters}
        activeFiltersCount={clientActiveFiltersCount}
        onFilterClick={() => {
          setFilterTarget("client");
          setShowFilters(true);
        }}
      />
      <MISFilterDrawer
        open={showFilters}
        onClose={() => setShowFilters(false)}
        filters={
          filterTarget === "client"
            ? clientFilters
            : filterTarget === "history"
            ? historyFilters
            : filterTarget === "duration"
            ? durationFilters
            : overviewFilters
        }
        setFilters={
          filterTarget === "client"
            ? setClientFilters
            : filterTarget === "history"
            ? setHistoryFilters
            : filterTarget === "duration"
            ? setDurationFilters
            : setOverviewFilters
        }
        divisions={divisions}
        users={users}
        stages={stages}
        // industries={[]}
        onApply={handleApplyFilters}
        onReset={(resetData) => {
          switch (filterTarget) {
            case "overview":
              setOverviewFilters(resetData);
              fetchOverview();
              break;

            case "duration":
              setDurationFilters(resetData);
              fetchDuration();
              break;

            case "history":
              setHistoryFilters(resetData);
              fetchHistory(1, resetData);
              break;

            case "client":
              setClientFilters(resetData);
              fetchClientList(1, resetData);
              break;

            default:
              break;
          }
        }}
        
      />
    </div>
  );
};

export default ClientStageReport;
